import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// IMPORTAMOS IMÁGENES LOCALES PARA EL BUFFET
import moleImg from '../assets/buffet-mole.jpg';
import cochinitaImg from '../assets/buffet-cochinita.jpg';
import pescadoImg from '../assets/buffet-pescado.jpg';
import huevosImg from '../assets/buffet-huevos.jpg';
import chilaquilesImg from '../assets/buffet-chilaquiles.jpg';
import flanImg from '../assets/buffet-flan.jpg';
import buffetGeneralImg from '../assets/buffet-general.jpg';
import cocinaBarroImg from '../assets/cocina-humo.jpg';

const Restaurante = () => {
  const [showDietaryInfo, setShowDietaryInfo] = useState(false);

  const buffetItems = [
    {
      id: 1,
      nombre: 'Mole Poblano con Café',
      descripcion: 'Tradicional mole con toques de café, servido con pollo, arroz blanco y ajonjolí',
      precio: '$180',
      imagen: moleImg,
      tags: ['tradicional', 'contiene gluten', 'puede contener frutos secos'],
      opciones: ['Versión sin gluten disponible', 'Versión vegetariana disponible']
    },
    {
      id: 2,
      nombre: 'Cochinita Pibil en Olla de Barro',
      descripcion: 'Marinada con achiote y café, cocida en olla de barro por 6 horas, servida con cebolla morada',
      precio: '$165',
      imagen: cochinitaImg,
      tags: ['tradicional', 'sin gluten', 'contiene carne'],
      opciones: ['Versión vegetariana con hongos disponible']
    },
    {
      id: 3,
      nombre: 'Pescado a la Veracruzana',
      descripcion: 'Filete de pescado con salsa de jitomate, aceitunas, alcaparras y un toque de café',
      precio: '$200',
      imagen: pescadoImg,
      tags: ['mariscos', 'sin gluten', 'pescado'],
      opciones: ['Opción sin alcaparras disponible']
    },
    {
      id: 4,
      nombre: 'Huevos al Comal con Café',
      descripcion: 'Huevos estrellados servidos con salsa de café y frijoles refritos, acompañados de tortillas hechas a mano',
      precio: '$120',
      imagen: huevosImg,
      tags: ['desayuno', 'vegetariano', 'sin gluten'],
      opciones: ['Versión vegana con tofu disponible', 'Sin lactosa disponible']
    },
    {
      id: 5,
      nombre: 'Chilaquiles con Mole de Café',
      descripcion: 'Totopos bañados en mole especial con notas de café, crema, queso fresco y cebolla encurtida',
      precio: '$135',
      imagen: chilaquilesImg,
      tags: ['tradicional', 'desayuno', 'contiene gluten', 'contiene lácteos'],
      opciones: ['Totopos horneados disponibles', 'Queso sin lactosa disponible', 'Salsa aparte']
    },
    {
      id: 6,
      nombre: 'Flan de Café',
      descripcion: 'Flan cremoso con caramelo y esencia de café, decorado con granos de café caramelizados',
      precio: '$80',
      imagen: flanImg,
      tags: ['postre', 'dulce', 'contiene huevo', 'contiene lácteos'],
      opciones: ['Versión vegana disponible', 'Endulzado con stevia disponible']
    }
  ];

  const dietaryInfo = {
    alergias: [
      '🌾 Gluten (tenemos opciones sin gluten)',
      '🥛 Lactosa (disponemos de opciones sin lactosa)',
      '🥜 Frutos secos (algunos platos pueden contener, consultar)',
      '🫘 Soya (presente en algunas salsas)',
      '🌽 Maíz (tortillas, totopos)'
    ],
    preferencias: [
      '🌱 Vegetariano (contamos con opciones)',
      '🌿 Vegano (disponemos de alternativas)',
      '🩵 Diabético (podemos ajustar azúcares)',
      '⚖️ Bajo en sodio (disponible bajo pedido)',
      '🔥 Sin picante (opciones suaves disponibles)'
    ]
  };

  return (
    <div className="restaurante-page">
      {/* Hero Section */}
      <section className="restaurante-hero">
        <div className="restaurante-hero-overlay"></div>
        <div className="restaurante-hero-content">
          <h1>Cocina Tradicional de Humo</h1>
          <p>Buffet en ollas de barro con técnicas ancestrales</p>
          <button 
            className="btn-primary"
            onClick={() => document.getElementById('buffet-section')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Ver Buffet
          </button>
        </div>
      </section>

      {/* Sobre el Buffet */}
      <section className="restaurante-about">
        <div className="restaurante-about-container">
          <div className="restaurante-about-content">
            <span className="about-badge">TRADICIÓN ANCESTRAL</span>
            <h2>Cocina Tradicional de Humo</h2>
            <h3>Sabores que cuentan historias</h3>
            <p>
              Nuestro buffet ofrece una experiencia única donde el café es un ingrediente fundamental 
              en nuestra cocina. Todos nuestros platillos son preparados en <strong>ollas de barro</strong> 
              con la técnica tradicional de humo que hemos preservado por generaciones.
            </p>
            <p>
              La cocina en barro permite una cocción uniforme, intensifica los sabores y conserva los 
              nutrientes de los alimentos, ofreciendo resultados únicos que no encontrarás en ningún otro lugar.
            </p>
            
            <div className="restaurante-stats">
              <div className="stat">
                <span className="stat-number">15+</span>
                <span className="stat-label">Platillos en buffet</span>
              </div>
              <div className="stat">
                <span className="stat-number">100%</span>
                <span className="stat-label">Cocina en barro</span>
              </div>
              <div className="stat">
                <span className="stat-number">10</span>
                <span className="stat-label">Personas mínimo</span>
              </div>
            </div>
          </div>
          
          <div className="restaurante-about-image">
            <img 
              src={cocinaBarroImg} 
              alt="Cocina tradicional de humo en ollas de barro"
            />
            
          </div>
        </div>
      </section>

      {/* Información de Alergias y Preferencias */}
      <section className="dietary-info-section">
        <div className="dietary-info-container">
          <button 
            className="dietary-toggle-btn"
            onClick={() => setShowDietaryInfo(!showDietaryInfo)}
          >
            <span>🍽️</span>
            Información sobre alergias y preferencias alimenticias
            <span className={`toggle-icon ${showDietaryInfo ? 'open' : ''}`}>▼</span>
          </button>
          
          {showDietaryInfo && (
            <div className="dietary-info-content">
              <div className="dietary-message">
                <h3>Estamos a tu disposición</h3>
                <p>
                  En Román Valderrábano El Catador nos preocupamos por todos nuestros comensales. 
                  Si tienes alguna alergia, intolerancia o preferencia alimenticia 
                  (vegetariano, vegano, diabético, etc.), por favor notifícalo al 
                  momento de hacer tu reservación. Nuestro chef ajustará los platillos 
                  especialmente para ti.
                </p>
              </div>
              
              <div className="dietary-grid">
                <div className="dietary-card">
                  <h4>🚨 Alergias e Intolerancias</h4>
                  <ul>
                    {dietaryInfo.alergias.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
                
                <div className="dietary-card">
                  <h4>🌱 Preferencias Alimenticias</h4>
                  <ul>
                    {dietaryInfo.preferencias.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
              
              <div className="dietary-note">
                <p>
                  <strong>Nota importante:</strong> Todos nuestros platillos se preparan en la misma 
                  área de cocina. Aunque tomamos todas las precauciones necesarias, puede haber 
                  contacto cruzado con alérgenos. Si tienes una alergia severa, por favor 
                  menciónalo al reservar para tomar medidas adicionales.
                </p>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Sección de Buffet */}
      <section id="buffet-section" className="buffet-gallery-section">
        <div className="buffet-gallery-header">
          <h2>Nuestro Buffet Tradicional</h2>
          <p>Platos preparados en ollas de barro con recetas ancestrales</p>
          <p className="buffet-requisito">* Mínimo 10 personas *</p>
        </div>

        <div className="buffet-gallery-grid">
          {buffetItems.map(item => (
            <div key={item.id} className="buffet-item">
              <img src={item.imagen} alt={item.nombre} />
              <div className="buffet-overlay">
                <h3>{item.nombre}</h3>
                <p>{item.descripcion}</p>
                <div className="buffet-tags">
                  {item.tags.map((tag, idx) => (
                    <span key={idx} className="buffet-tag">{tag}</span>
                  ))}
                </div>
                <div className="buffet-opciones">
                  <small>Opciones disponibles:</small>
                  {item.opciones.map((opc, idx) => (
                    <span key={idx} className="buffet-opcion">{opc}</span>
                  ))}
                </div>
                <span className="price">{item.precio}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Información del Buffet */}
      <section className="buffet-info-section">
        <div className="buffet-info-container">
          <div className="buffet-info-card">
            <h3>🍽️ ¿Cómo funciona el buffet?</h3>
            <p>
              Nuestro buffet se sirve de manera tradicional, con todos los platillos en ollas de barro 
              manteniendo su temperatura y sabor. Puedes servirte las veces que desees y probar 
              todos los platillos disponibles.
            </p>
          </div>
          
          <div className="buffet-info-card">
            <h3>🕒 Horarios del buffet</h3>
            <p><strong>Desayuno buffet:</strong> 8:00 am - 11:00 am</p>
            <p><strong>Comida buffet:</strong> 1:00 pm - 5:00 pm</p>
            <p><strong>Cena buffet:</strong> 6:00 pm - 9:00 pm (solo viernes y sábados)</p>
          </div>
          
          <div className="buffet-info-card">
            <h3>💰 Precios del buffet</h3>
            <p><strong>Desayuno buffet:</strong> $220 MXN por persona</p>
            <p><strong>Comida buffet:</strong> $280 MXN por persona</p>
            <p><strong>Cena buffet:</strong> $250 MXN por persona</p>
            <p className="buffet-note">* Mínimo 10 personas *</p>
          </div>
        </div>
      </section>

      {/* Sección de Reservas */}
      <section className="buffet-reserva-section">
        <div className="buffet-reserva-container">
          <h2>Reserva tu experiencia de buffet</h2>
          <p>Te esperamos en la Sierra Norte de Puebla para disfrutar de nuestra cocina tradicional de humo</p>
          
          <div className="buffet-reserva-grid">
            <div className="buffet-contacto">
              <h3>📞 Contacto para reservaciones</h3>
              <p><strong>Teléfono:</strong> +52 (228) 123-4567</p>
              <p><strong>Email:</strong> restaurante@cafeelcatador.com</p>
              <p><strong>WhatsApp:</strong> +52 228 123 4567</p>
              <p className="reserva-nota">
                Al hacer tu reservación, por favor menciona:
                <br />- Número de personas
                <br />- Horario preferido
                <br />- Alergias o preferencias alimenticias
              </p>
            </div>
            
            <div className="buffet-requisitos">
              <h3>📋 Requisitos</h3>
              <ul>
                <li>Mínimo 10 personas</li>
                <li> Reservar con 48 horas de anticipación</li>
                <li> Grupos máximos de 50 personas</li>
                <li> Mención de alergias al reservar</li>
                <li> Pago por adelantado para grupos grandes</li>
              </ul>
            </div>
          </div>
          
          <div className="buffet-cta">
            <button className="btn-primary btn-large">
              Reservar Buffet
            </button>
          </div>
        </div>
      </section>

      {/* Ubicación */}
      <section className="restaurante-info-section">
        <div className="info-container">
          <div className="info-card">
            <div className="info-icon">⏰</div>
            <h3>Horarios</h3>
            <p><strong>Lunes a Viernes:</strong> 8:00 am - 8:00 pm</p>
            <p><strong>Sábados:</strong> 8:00 am - 10:00 pm</p>
            <p><strong>Domingos:</strong> 9:00 am - 6:00 pm</p>
          </div>
          
          <div className="info-card highlight">
            <div className="info-icon">📍</div>
            <h3>Ubicación</h3>
            <p><strong>Dirección:</strong> Zaragoza 146, Centro</p>
            <p>Xicotepec de Juárez, Puebla</p>
            <p><strong>Sierra Norte de Puebla - Pueblo Mágico</strong></p>
          </div>
          
          <div className="info-card">
            <div className="info-icon">🎉</div>
            <h3>Eventos Privados</h3>
            <p>Organizamos eventos corporativos, bodas y celebraciones con buffet personalizado</p>
            <p><strong>Capacidad:</strong> hasta 50 personas</p>
            <p><strong>Menú personalizado</strong> con cocina de humo</p>
            <button className="btn-secondary btn-small">
              Solicitar Información
            </button>
          </div>
        </div>

        <div className="social-section">
          <h3>Síguenos en redes</h3>
          <div className="social-links">
            <button className="social-icon" onClick={() => window.open('https://instagram.com', '_blank')}>
              📷
            </button>
            <button className="social-icon" onClick={() => window.open('https://facebook.com', '_blank')}>
              📘
            </button>
            <button className="social-icon" onClick={() => window.open('https://tiktok.com', '_blank')}>
              🎵
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Restaurante;